import React from 'react';
import './Modal.css'

const Modal = ({children, isOpen, closeModal}) =>{
    const handleModalContainerClick = e => e.stopPropagation();
    return (
        <article className={`modal ${isOpen && "is-open"}`} onClick={closeModal}>
            <div className="modal-container" onClick={handleModalContainerClick}>
                {children}
            </div>
        </article>
    )
}

export default Modal;